var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "body" }, [
    _c("div", { staticClass: "close-btn", on: { click: _vm.close } }, [
      _c(
        "i",
        { staticClass: "material-icons md-18", attrs: { title: "close" } },
        [_vm._v("close")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "title" }, [_vm._v("EDIT COLLECTION NAME")]),
    _vm._v(" "),
    _c("div", { staticClass: "p-3" }, [
      _c(
        "form",
        {
          staticClass: "category form-group",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.formSubmit.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "modal-property-row" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.rec.name,
                  expression: "rec.name"
                }
              ],
              staticClass: "form-control",
              class: { "is-invalid": _vm.error },
              attrs: { type: "text", placeholder: "Enter a name" },
              domProps: { value: _vm.rec.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.rec, "name", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "invalid-feedback" }, [
              _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.error) + "\n\t\t\t   ")
            ])
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-actions" }, [
      _c(
        "button",
        { staticClass: "btn btn-dark float-right", attrs: { type: "submit" } },
        [_vm._v("Save")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a74a710", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a74a710","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/collection/collection-edit.vue
// module id = null
// module chunks = 